/**
 * @name 检查delivery的pin规则
 */
const checkDeliveryPIN: RuleMethod = (rule, val, callBack) => {
    const value = val as string;
    const regStart9 = /^9\S{7}$/;
    if (regStart9.test(value)) {
        return callBack(new Error(WordList.ProperAllTextPmDeliveryKeyRule));
    }

    return callBack();
};

/**
 * @name 检查开门密码pin有效性
 */
const checkPin = (encrypt: boolean, type: 'delivery'|'resident'): RuleMethod => (rule, val, callback) => {
    const value = val as string;
    if (value === '') {
        return callback();
    }
    const regForNumber = /^\+?[0-9]*$/;
    const regForEncrypt = /^\+?[*]{4}$/;

    // delivery
    if (type === 'delivery') {
        if (!regForEncrypt.test(value)) {
            return checkDeliveryPIN(rule, value, callback);
        }
        return callback();
    }

    if (encrypt && !regForNumber.test(value) && !regForEncrypt.test(value)) {
        return callback(new Error(WordList.RuleCommonNumber));
    }
    if (!encrypt && !regForNumber.test(value)) {
        return callback(new Error(WordList.RuleCommonNumber));
    }
    if ((value).length > 8 || (value).length < 2) {
        return callback(
            new Error(WordList.RuleCommonRang.format('2', '8'))
        );
    }
    return callback();
};

/**
 * @name 检查门禁卡rfcard有效性
 */
const checkCard: RuleMethod = (rule, value, callback) => {
    if (value === '') {
        return callback();
    }
    const reg = /^\+?[0-9A-F]*$/;
    if (!reg.test(value as string)) {
        return callback(new Error(WordList.RuleKeyInvalid));
    }
    return callback();
};

export default null;
export {
    checkDeliveryPIN,
    checkPin,
    checkCard
};